import React from 'react';
import { accent0 } from '../globals/colors';
import styled from 'styled-components';
import { staticUrl } from '../globals/urls';
import { Token } from './Token.style';
import { Svg } from '../Svg';

export var TruckToken = styled(Token).attrs(function () {return {
    children: /*#__PURE__*/React.createElement(Svg, { url: staticUrl('images/truck.svg') })
  };}).withConfig({ displayName: "TruckToken", componentId: "sc-tnlcxl-0" })(["background:", ";"],
accent0);
//# sourceMappingURL=TruckToken.js.map